import { DashboardLayout } from 'layouts/DashboardLayout';

export const Dashboard = () => {
  return <DashboardLayout>Welcome</DashboardLayout>;
};
